import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import ButtonBase from '@mui/material/ButtonBase';
import { Grid } from '@mui/material';
import { useTheme } from '@emotion/react';



function TimeSlots({ timeSlots, timeSlot, onTimeSlotChange, slot, onSlotChange, error, onErrorChange }) {

    const { t } = useTranslation()
    const theme = useTheme()
    // Styles
    const styles = {
        tabsRoot: {
            backgroundColor: theme.palette.background.default,
            indicator: theme.palette.success.main,
            color: theme.palette.primary.main,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[3]
        },
        tabRoot: {
            textTransform: 'none',
            minWidth: '64px',
            flexGrow: 1,
        },
        buttonBaseRoot: {
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: theme.palette.mode === 'dark' ? theme.palette.background.default : '#dcd1d1',
            borderRadius: '18px',
            backgroundColor: theme.palette.background.default,
            width: '100%',
            padding: theme.spacing(1),
            border: 'solid 0.5px gray'

        },
        buttonBaseSelectedRoot: {
            borderStyle: 'solid',
            borderWidth: '1px',
            borderColor: theme.palette.success.main,
            borderRadius: '18px',
            backgroundColor: theme.palette.success.main,
            color: theme.palette.success.contrastText,
            width: '100%',
            padding: theme.spacing(1),
        },
        emptyTab: {
            display: 'none'
        }
    }

    // On mount
    useEffect(() => {

        // Select intial, if none seleced previously
        if (!timeSlot && timeSlots && timeSlots[0]) onTimeSlotChange(timeSlots[0])

        return () => {
            // Clean up
        }

    }, [])

    // On time slot change 
    useEffect(() => {

        // If old slot not exist in new time slot, clear slot
        if (timeSlot) {
            if (!timeSlot.slots.find(f => f === slot)) {
                onSlotChange('')
            }
        }
    }, [timeSlot])

    return (
        <Grid container spacing={1}>
            <Grid item xs={12} sm={12} md={12}>
                <Typography variant='h6' color='textPrimary' align='center'>
                    Tarih
                </Typography>
            </Grid>
            <Box m={1} />
            {/* Tabs */}
            <Grid item xs={12}>
                <Tabs
                    value={timeSlot}
                    onChange={(event, newValue) => onTimeSlotChange(newValue)}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="primary"
                    sx={styles.tabsRoot}
                >
                    {
                        timeSlots.map((timeSlot, idx) => (
                            <Tab
                                value={timeSlot}
                                sx={styles.tabRoot}
                                label={
                                    <>
                                        <Typography variant='body1' color='textPrimary'>
                                            {moment(timeSlot.date).format('ddd')}
                                        </Typography>
                                        <Typography variant='body1' color='textPrimary'>
                                            {moment(timeSlot.date).format('DD')}
                                        </Typography>
                                    </>
                                }
                                key={idx}
                            />
                        ))
                    }
                    {/* Empty tab */}
                    <Tab
                        value={''}
                        SX={styles.emptyTab}
                    />
                </Tabs>
            </Grid>

            {/* Content */}
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    {
                        timeSlot &&
                        timeSlot.slots.map((slot_, idx) => {
                            const isSelected = slot_ === slot

                            return (
                                <Grid item xs={3} key={idx}>
                                    <ButtonBase
                                        sx={!isSelected ? styles.buttonBaseRoot : styles.buttonBaseSelectedRoot}
                                        onClick={() => {
                                            onSlotChange(slot_)
                                            onErrorChange(false)
                                        }}
                                    >
                                        {
                                            !isSelected ?
                                                <Typography variant='body1' color='textPrimary'>{slot_}</Typography> :
                                                <Typography variant='body1'>{slot_}</Typography>
                                        }
                                    </ButtonBase>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            </Grid>

            {/* Error Text */}
            {
                error &&
                <Grid item xs={12}>
                    <Box w={1} alignItems='center'>
                        <Typography variant='body2' color='error'>{`${t('timeSlotError')}`}</Typography>
                    </Box>
                </Grid>
            }
        </Grid>
    )
}

// Connect redux and translation
export default TimeSlots